//library
import { Fragment } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap'

const Index = (props) => {

  return (
    <Fragment >
      <Modal
        isOpen={props?.modal}
        toggle={() => !props?.loading && props?.toggleHandler()}
        className={'modal-dialog-centered modal-lg'}
        backdrop={props?.loading ? "static" : undefined}
      >
        <ModalHeader toggle={() => !props?.loading && props?.toggleHandler()}>
          {props?.modalTitle}
          {props?.title}
        </ModalHeader>
        {
          props?.loading ?
            <ModalBody style={{ pointerEvents: 'none' }}>
              {props?.children}
            </ModalBody> :
            <ModalBody>
              {props?.children}
            </ModalBody>
        }
        <ModalFooter>
          {props?.loading ? <Spinner /> :
            <Button color='primary' onClick={() => props?.toggleHandler()}>
              Close
            </Button>
          }
        </ModalFooter>
      </Modal>

    </Fragment>
  );
}

export default Index;
